import { JSX } from 'react'

import BuildingIcon from '../../assets/logo/Building.svg'

const BuildingCustomIcon = (): JSX.Element => <img src={BuildingIcon} alt="logo" />

export default BuildingCustomIcon
